import { useInjection } from 'inversify-react';

import { IManageBookingRepository } from 'domain/repositories/ManageBookingsRepository';

export const useCaseListMyBookings = (isUS: boolean) => {
  const repository = useInjection<IManageBookingRepository>(IManageBookingRepository);
  return repository.useListMyBookings(isUS);
};
